import React, { PropsWithChildren } from 'react';
import { SocialPermissionsProvider } from '../function-providers/SocialPermissionsProvider';

const SocialProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return <SocialPermissionsProvider>{children}</SocialPermissionsProvider>;
};

export default SocialProvider;
